module.exports = __webpack_public_path__ + "media/pry/bghead-eaae6f42.png";